<template>
    <Modal ref="modal" :title="title" size="is-xxxlarge" paddingless @closed="reset">
        <Audits
            v-if="auditableType && auditableId !== null"
            :key="`${auditableType}:${auditableId}`"
            :model="auditableType"
            :model-id="auditableId"
        />
    </Modal>
</template>

<script setup lang="ts">
import Audits from '@/js/components/pages/Admin/Tables/Audits.vue';
import Modal from '@/js/components/Modal.vue';
import { Eventbus } from '@/js/utils/eventbus.ts';
import { computed, nextTick, onMounted, onUnmounted, ref, useTemplateRef } from 'vue';

interface AuditsModalPayload {
    auditableType: string;
    auditableId: number;
}

const modal = useTemplateRef('modal');
const auditableType = ref<string | null>(null);
const auditableId = ref<number | null>(null);

const title = computed(() => (auditableType.value ? `${auditableType.value.split('\\').pop()} audits` : 'Audits'));

async function open(payload: AuditsModalPayload): Promise<void> {
    auditableType.value = payload.auditableType;
    auditableId.value = payload.auditableId;

    await nextTick();
    modal.value?.open();
}

function reset(): void {
    auditableType.value = null;
    auditableId.value = null;
}

onMounted(() => {
    Eventbus.$on('audits:open', open);
});

onUnmounted(() => {
    Eventbus.$off('audits:open', open);
});
</script>
